import React from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import { BOAT, TRAIN } from 'Components/widgets/transport-details/transportUtils';
import { t } from 'Src/i18n';
import { CopyButton } from 'Components/widgets/copy-button/CopyButton';

const getLabel = (type: string) => {
  switch (type) {
    case BOAT:
      return 'common.transport.pnrBoatTutorial';

    case TRAIN:
      return 'common.transport.pnrTrainTutorial';

    default:
      return 'common.transport.pnrTutorial';
  }
};

type Props = {
  attendees: Array<TransportAttendee>;
  className?: string;
  onClickCopy?: () => void;
  type: string;
};
export const TransportDetailsTravelSectionReference = ({
  attendees = [],
  className,
  onClickCopy,
  type,
}: Props) => {
  if (!attendees?.length) {
    return null;
  }

  const reference = attendees?.[0]?.pnr;

  if (!reference) {
    return null;
  }

  return (
    <div
      className={classnames(
        'space-y-10 rounded-12 border-1 border-lightGrey bg-white p-20',
        className,
      )}
    >
      <p className="text-16 font-bold">{t('common.transport.pnrReferenceNumber')}</p>
      <p className="text-14">{t(getLabel(type))}</p>
      <CopyButton copiedLabel={t('common.transport.pnrCopied')} onClick={onClickCopy}>
        {reference}
      </CopyButton>
    </div>
  );
};
